// extracted by mini-css-extract-plugin
export default {"userId":"UserSelect_userId__NZzfm","userType":"UserSelect_userType__fjxIk"};